/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmStat extends GContentBase<SeznamAdmStatObj> {
        private seznamObj: SeznamAdmStatObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmStatObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmStatNew",
                contentCaption: "jres:33000097",
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{stat}"
                },
                gridSettings: {
                    columnOrder: "stat,stat_txt,dat_zmena,zmenu_provedl,stat_sis_aa,stat_sis_aaa,stat_sis_nnn,svetadil_txt,priz_eu_txt,kod_zeme_eu,priz_iban_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmStatObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmStat", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmStat",
                newRecord: isNew,
                stat: isNew == true ? null : data.stat
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*"])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmStat.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.stat),
                nazev: data["stat_txt"]
            }
        }
    }
}